<div class='panel panel-primary'>

  <div #popBox style="position:absolute;width:1px;height:1px;">
    <!--<ng-template #popTitle let-language="language"></ng-template>-->
    <ng-template #popContent let-greeting="greeting">
      <div class="clearfix input-section memberPop">
        <div class="section-45 profile-info">
          <div class="clearfix">
            <div class="profile-pic fl s2">
              <img [src]="profileImageUrl" alt="profile" />
            </div>
          </div>
          <div class="clearfix">
            <div class="title"> <b> {{popMember.Salutation}} {{popMember.FirstName}} {{popMember.LastName}} </b> </div>
          </div>
          <div class="clearfix">
            <span class="fieldname">Reg ID:</span> <span class="fieldvalue"> {{popMember.IdentityId}}</span>
          </div>
          <div class="clearfix">
            <span class="fieldname">User Name: </span> <span class="fieldvalue"> {{popMember.UserName}}</span>
          </div>


        </div>
        <div class="section-50 profile-info">
          <div class="clearfix">
            <span class="fieldname">Active:</span> <span class="fieldvalue"><mat-checkbox [disabled]="true" [(ngModel)]="popMember.IsActive"></mat-checkbox> </span>
          </div>
          <div class="clearfix">
            <span class="fieldname">Start:</span> <span class="fieldvalue"> {{popMember.MembershipStartDate?.toLocaleDateString('en-GB')}}</span>
          </div>
          <div class="clearfix">
            <span class="fieldname">End:</span> <span class="fieldvalue"> {{popMember.MembershipExpiryDate?.toLocaleDateString('en-GB')}}</span>
          </div>
          <div class="clearfix">
            <span class="fieldname">Date of Birth: </span> <span class="fieldvalue"> {{popMember.DateOfBirth?.toLocaleDateString('en-GB')}}</span>
          </div>
          <div class="clearfix">
            <span class="fieldname">Trainer: </span> <span class="fieldvalue"> {{popMember.AssignedTrainer?.FirstName}} {{popMember.AssignedTrainer?.LastName}}</span>
          </div>
          <div class="clearfix">
            <span class="fieldname">Referred By:</span> <span class="fieldvalue"> {{popMember.ReferredBy?.FirstName}} {{popMember.ReferredBy?.LastName}} </span>
          </div>
          <div class="clearfix">
            <span class="fieldname">Enrolled By:</span> <span class="fieldvalue">{{popMember.EnrolledBy?.FirstName}} {{popMember.EnrolledBy?.LastName}} </span>
          </div>
          <div class="clearfix">
            <span class="fieldname">Occupation:</span> <span class="fieldvalue">{{popMember.Occupation}} </span>
          </div>
          <div class="clearfix">
            <span class="fieldname">Contact:</span> <span class="fieldvalue"> {{popMember.Contact1}} {{popMember.Contact2 ?"/ "+popMember.Contact2 : ""}}</span>
          </div>
          <div class="clearfix">
            <span class="fieldname">Email:</span> <span class="fieldvalue"> {{popMember.Email}}</span>
          </div>
        </div>
      </div>

    </ng-template>
    <div class="btnPopoverTrigger"
         [ngbPopover]="popContent"
         popoverTitle=""
         [autoClose]="true"
         ngbPopover=""
         popoverClass="popOverride"
         #memberInfoPop="ngbPopover" placement="auto">
    </div> <!--[popoverTitle]="popTitle"-->
  </div>

  <div class="alert alert-info" role="alert" *ngIf="indLoading"><img src="../../assets/images/loader2.gif" width="32" height="32" /> Loading...</div>
  <div class="filter-controls">
    <!--<input type="text" class="form-control search-box" [value]="filter" (input)="filter = $event.target.value" (keyup.enter)="filterChange();" placeholder="Filter">-->
    <div class="search-box" style="padding-top:12px;">
      <span>&nbsp;</span>

    </div>
    <div class="fl" style="width:412px;">
      <div class="fl expiringMembership" style="width:175px;">
        Memberships expiring in:
      </div>
      <div class="field-s fl" style="margin-top:3px;width:30px;">
        <input type="Number" class="input-element-nb w-100" placeholder="Days" [(ngModel)]="dayCount" (change)="dayCountChanged()">
      </div>
      <div class="fl expiringMembership padding-lxs" style="width:50px;">
        Days
      </div>
      <div class="fl" style="border-left: 1px solid #595959; padding-left: 14px; font-size: 13px; font-weight: bold; height:36px; ">
        <mat-form-field class="fl field-m textfield-mr2 mat-custom-label-adjust">
          <mat-select placeholder="Filter By" [(ngModel)]="selectedFilter" style="height:23px;" (selectionChange)="filterChanged()">
            <mat-option *ngFor="let f of dataFilter" [value]="f">
              {{f}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <input type="button" class="fl filterBtn hide" value="View" (click)="getCollectionData()" />
    </div>

    <mat-form-field class="form-element field-l textfield-mr2 hide">
      <mat-label>From Date</mat-label>
      <input matInput [matDatepicker]="startpicker" [(ngModel)]="fromDate">
      <mat-datepicker-toggle matSuffix [for]="startpicker"></mat-datepicker-toggle>
      <mat-datepicker #startpicker></mat-datepicker>
    </mat-form-field>

    <mat-form-field class="form-element field-l textfield-mr2 hide">
      <mat-label>To Date</mat-label>
      <input matInput [matDatepicker]="endpicker" [(ngModel)]="toDate">
      <mat-datepicker-toggle matSuffix [for]="endpicker"></mat-datepicker-toggle>
      <mat-datepicker #endpicker></mat-datepicker>
    </mat-form-field>


  </div>
  <jqxGrid #dataGrid [theme]="'material-purple'" (onSort)="dataGridOnSort($event)" (onPagesizechanged)="onPageSizeChanged($event)"
           [width]="'99.8%'" [source]="dataAdapter" [columns]="columns"
           [pageable]="true" [sortable]="true" [editable]="false"
           [autoheight]="true" [enabletooltips]="true" [pagermode]="'default'"
           [virtualmode]="true" [rendergridrows]="rendergridrows" [pagesizeoptions]="['10','20','50']" (onBindingcomplete)="Bindingcomplete($event)">
  </jqxGrid>


</div>

